<template>
    <div>
      <iframe :src="iframeSrc" frameborder="0" style="width: 100%; height: 100vh;"></iframe>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        // Path to the HTML page you want to import
        iframeSrc: '../blocks/test.html'
      };
    }
  };
  </script>
  